<template>
  <div class="residential-address">
    <div class="residential-address__fields">
      <InputComponent
        :value="getValue('street')"
        @input="$ev => setValue('street', $ev)"
        :label="$t('street')"
        :disabled="disabled"
        data-field="street"
      />
      <InputComponent
        :value="getValue('city')"
        @input="$ev => setValue('city', $ev)"
        :label="$t('city')"
        :disabled="disabled"
        data-field="city"
      />

      <InputComponent
        :value="getValue('postcode')"
        @input="$ev => setValue('postcode', $ev)"
        :label="$t('postcode')"
        :disabled="disabled"
        data-field="postcode"
      />

      <InputComponent
        :value="getValue('county')"
        @input="$ev => setValue('county', $ev)"
        :label="$t('county')"
        :disabled="disabled"
        data-field="county"
      />
    </div>
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { i18n } from '@/i18n'
import { Clone, setByPath } from '@/utils'

const meta = {
  order: 4,
  label: i18n.tc('address'),
}

export { meta }

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: Boolean,
    defaultAddress: Object,
  },
  watch: {
    value: {
      handler(val) {
        if (!val) return
        this.data = Clone(val)
      },
      immediate: true,
    },
  },
  data() {
    return {
      data: {},
    }
  },
  computed: {
    label: () => meta.label,
  },
  methods: {
    getValue(key) {
      return this.$path('data.' + key)
    },
    setValue(key, value) {
      setByPath(key, value, this.data)
      this.$emit('input', this.data)
    },
  },
  created() {
    if (!this.defaultAddress) return
    Object.entries(this.defaultAddress).forEach(([key, value]) => {
      if (this.getValue(key)) return
      this.setValue(key, value)
    })
  },
  components: {
    InputComponent,
  },
}
</script>

<style lang="scss">
.residential-address {
  &__fields {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 1rem;
    padding-top: 0.5rem;

    [data-field='street'] {
      grid-column-end: span 6;
    }

    [data-field='postcode'],
    [data-field='city'],
    [data-field='county'] {
      grid-column-end: span 2;
    }
  }
}
</style>
